import { faIdCard as IconeModoParticipacao } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { makeObservable, observable } from 'mobx';
import ModoParticipacaoAdvogado, { MODO_PARTICIPACAO_ADVOGADO } from '../../dominio/ModoParticipacaoAdvogado';
import { Filtro, TIPO_CONJUNTO_OPCOES_FILTRO } from './Filtro';

export default class FiltroAdvogadoModoParticipacao extends Filtro {
    tipo = 'selecao';
    exibicao = 'select';
    selecaoMultipla = true;

    get label() {
        return 'Modo de participação dos advogados';
    }

    getIconeFiltroRapido() {
        return (
            <FontAwesomeIcon
                icon={IconeModoParticipacao}
                style={{ fontSize: '22px' }}
            />
        );
    }

    opcoesFiltro = FiltroAdvogadoModoParticipacao.#carregarOpcoes();

    filtroRapido = { opcoes: this.getOpcoesFiltro('valor', 'cor') };

    static #carregarOpcoes() {
        return [
            {
                valor: MODO_PARTICIPACAO_ADVOGADO.INDEFINIDO.codigo,
                cor: MODO_PARTICIPACAO_ADVOGADO.INDEFINIDO.cor,
                icone: ModoParticipacaoAdvogado.getIcone(MODO_PARTICIPACAO_ADVOGADO.INDEFINIDO.id, '28px')
            },
            {
                valor: MODO_PARTICIPACAO_ADVOGADO.VIRTUAL.codigo,
                cor: MODO_PARTICIPACAO_ADVOGADO.VIRTUAL.cor,
                icone: ModoParticipacaoAdvogado.getIcone(MODO_PARTICIPACAO_ADVOGADO.VIRTUAL.id, '24px')
            },
            {
                valor: MODO_PARTICIPACAO_ADVOGADO.PRESENCIAL.codigo,
                cor: MODO_PARTICIPACAO_ADVOGADO.PRESENCIAL.cor,
                icone: ModoParticipacaoAdvogado.getIcone(MODO_PARTICIPACAO_ADVOGADO.PRESENCIAL.id, '28px')
            },
            {
                valor: MODO_PARTICIPACAO_ADVOGADO.TELEPRESENCIAL.codigo,
                cor: MODO_PARTICIPACAO_ADVOGADO.TELEPRESENCIAL.cor,
                icone: ModoParticipacaoAdvogado.getIcone(MODO_PARTICIPACAO_ADVOGADO.TELEPRESENCIAL.id, '28px')
            },
            {
                valor: MODO_PARTICIPACAO_ADVOGADO.SUSTENTACAO_ORAL_ELETRONICA.codigo,
                cor: MODO_PARTICIPACAO_ADVOGADO.SUSTENTACAO_ORAL_ELETRONICA.cor,
                icone: ModoParticipacaoAdvogado.getIcone(
                    MODO_PARTICIPACAO_ADVOGADO.SUSTENTACAO_ORAL_ELETRONICA.id,
                    '28px'
                )
            },
            {
                valor: MODO_PARTICIPACAO_ADVOGADO.PEDIDO_DESTAQUE.codigo,
                cor: MODO_PARTICIPACAO_ADVOGADO.PEDIDO_DESTAQUE.cor,
                icone: ModoParticipacaoAdvogado.getIcone(MODO_PARTICIPACAO_ADVOGADO.PEDIDO_DESTAQUE.id, '28px')
            }
        ];
    }

    constructor(props) {
        super(props);

        makeObservable(this, {
            filtroRapido: observable
        });
    }

    get tipoConjuntoOpcoes() {
        return TIPO_CONJUNTO_OPCOES_FILTRO.COM_INTERSECAO;
    }

    getValorOpcao(registro) {
        let modosParticipacaoAdvs = new Set();

        registro.pedidoSustentacaoOral?.pedidosDetalhados?.forEach((pedido) => {
            pedido.advogados?.forEach((advogado) => {
                if (advogado.modoParticipacao) {
                    modosParticipacaoAdvs.add(advogado.modoParticipacao);
                } else {
                    modosParticipacaoAdvs.add(MODO_PARTICIPACAO_ADVOGADO.INDEFINIDO.codigo);
                }
            });
        });

        return Array.from(modosParticipacaoAdvs);
    }

    getDescricao(valor) {
        if (typeof valor === 'undefined') {
            return '';
        }

        return ModoParticipacaoAdvogado.getDescricao(ModoParticipacaoAdvogado.getIdByCodigo(valor));
    }
}
